import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ActionButton = styled(Link)`
  display: inline-block;
  align-self: center;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: bold;
  color: var(--color-button-text);
  background: var(--color-new-button-active);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
  text-decoration: none;
  margin: 0.5rem;

  &:hover {
    background: var(--color-new-button-active-hover);
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    color: var(--color-button-text);
  }

  &:focus {
    outline: 2px solid var(--color-highlight);
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    background: var(--color-disabled);
    color: #666;
    cursor: not-allowed;
  }
`;
